import { QueryKeys } from "@/constants/Query";
import type { ApiError } from "@/hooks/useApi";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface UpdateMaritalStatusRequest {
  maritalStatus: string;
}

export const useUpdateMaritalStatus = ({
  patientId,
  onSuccess,
  onError,
}: {
  patientId: string;
  onSuccess?: () => void;
  onError?: (error: ApiError) => void;
}) => {
  const queryClient = useQueryClient();
  return useApiMutation({
    mutationOptions: {
      mutationFn: (data: UpdateMaritalStatusRequest) =>
        axiosInstance.patch(
          `/new-api/patient/${patientId}/marital-status`,
          data,
        ),
      mutationKey:
        QueryKeys.Patient.MedicalRecords.SocialHistory.MARITAL_STATUS(
          patientId,
        ),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.DEFAULT(patientId),
        });
        onSuccess?.();
      },
      onError,
    },
  });
};
